import logo from "./logo.svg";
import "./App.css";
import NavBar from "./component/NavBar";
import MyRouter from "./component/MyRouter";

function App() {
  return <MyRouter />;
}

export default App;
